import {
    Box,
    CardContent,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper, Typography
} from "@mui/material";
import * as React from "react";
import {createTheme} from "@mui/material/styles";
import {lightGreen, red} from "@mui/material/colors";
import QuestionDescription from "./QuestionDescription";


const QuestionTrueFalseSolution = ({question, data, optionsOrder}) => {
    const correctColor = lightGreen[200];
    const incorrectColor = red[200];

    const checkboxCorrectTheme = createTheme({
        palette: {
            action: {
                disabled: correctColor
            }
        }
    });

    const checkboxIncorrectTheme = createTheme({
        palette: {
            action: {
                disabled: incorrectColor
            }
        }
    });

    const checkboxes = question["answers"]
        .sort((a, b) => optionsOrder[a.id] - optionsOrder[b.id])
        .map((answer) => {
                const dataMatchesAnswer = answer["correct"] === data[answer["id"]];
                return <FormControlLabel
                    key={answer["id"]}
                    control={
                        <Checkbox
                            key={answer["id"]}
                            checked={answer["correct"]}
                            disabled="true"
                            theme={answer["correct"] ? checkboxCorrectTheme : checkboxIncorrectTheme}
                        />
                    }
                    label={<Typography
                        sx={{color: answer["correct"] ? correctColor : incorrectColor}}>{answer["content"]}</Typography>}
                />
            }
        );

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
            <Paper elevation={10} sx={{m: 1, p: 1, maxWidth: 1000}}>
                <CardContent>
                    <QuestionDescription description={question["description"]}/>
                    <FormGroup>
                        {checkboxes}
                    </FormGroup>
                </CardContent>
            </Paper>
        </Grid>
    );
}

export default QuestionTrueFalseSolution;